import { Component, ElementRef, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { AuthService, ComponentBase } from 't4core';
import { OrderCustomerInfo } from '../../../../projects/t4core/src/public-api';


@Component({
  selector: 't4-ordercustomerinfo',
  templateUrl: './orderCustomerInfo.html',
  styleUrls: ['./orderCustomerInfo.css'],
})
export class T4OrderCustomerInfo extends ComponentBase implements OnInit {
  @Input() customerId: number;
  @Input() customer: OrderCustomerInfo;

  @ViewChild('gmap', {static: true}) gmapElement: ElementRef;

  private map: google.maps.Map;
  private pin: google.maps.Marker;

  constructor(private authService: AuthService) {
      super();
  }

  async ngOnInit() {
    await this.loadMap();
  }

    async ngOnChanges(changes: SimpleChanges) {  
      await this.loadMap();
  }


  public async loadMap() {
    var pos = new google.maps.LatLng(0, 0);
    if (this.customer && this.customer.Id > 0 && this.customer.Latitude && this.customer.Longitude) {
      pos = new google.maps.LatLng(this.customer.Latitude, this.customer.Longitude);
    } else if (this.customer) {
      var newCustomer = await this.Api.get<OrderCustomerInfo>("TurboOrder/GetOrderCustomerInfo", { customerId: this.customer.Id });
      pos = new google.maps.LatLng(newCustomer.Latitude, newCustomer.Longitude);
    }


    this.gmapElement.nativeElement.src = "https://maps.googleapis.com/maps/api/staticmap?center=" + pos.lat() + "," + pos.lng() + "&zoom=10&size=338x250&maptype=roadmap&markers=" + pos.lat() + "," + pos.lng() + "&key=AIzaSyAPITA4UuI9ERN_XiTDXZC1packZFkx-xE";
  }

}
